export enum Roles {
  Admin = "Admin",
  Dealer = "Dealer",
  Client = "Client",
  Seller = "Seller",
  DealerAdmin = "DealerAdmin",
}

export const RoleCodes = {
  Admin: 1,
  Dealer: 2,
  Client: 3,
  Seller: 4,
  DealerAdmin: 5,
} as const;

export type RoleCode = typeof RoleCodes[keyof typeof RoleCodes];

const ROLE_NAME_BY_CODE: Record<RoleCode, Roles> = {
  [RoleCodes.Admin]: Roles.Admin,
  [RoleCodes.Dealer]: Roles.Dealer,
  [RoleCodes.Client]: Roles.Client,
  [RoleCodes.Seller]: Roles.Seller,
  [RoleCodes.DealerAdmin]: Roles.DealerAdmin,
};

const ROLE_CODE_BY_NAME: Record<Roles, RoleCode> = {
  [Roles.Admin]: RoleCodes.Admin,
  [Roles.Dealer]: RoleCodes.Dealer,
  [Roles.Client]: RoleCodes.Client,
  [Roles.Seller]: RoleCodes.Seller,
  [Roles.DealerAdmin]: RoleCodes.DealerAdmin,
};

const isRoleName = (role: string): role is Roles =>
  Object.values(Roles).includes(role as Roles);

export function toRoleCode(
  role: Roles | RoleCode | string | number | null | undefined
): RoleCode | null {
  if (role === null || role === undefined) return null;
  if (typeof role === "number") {
    return ROLE_NAME_BY_CODE[role as RoleCode] ? (role as RoleCode) : null;
  }
  if (typeof role === "string") {
    const trimmed = role.trim();
    const numeric = Number(trimmed);
    if (!Number.isNaN(numeric)) {
      return ROLE_NAME_BY_CODE[numeric as RoleCode]
        ? (numeric as RoleCode)
        : null;
    }
    return isRoleName(trimmed) ? ROLE_CODE_BY_NAME[trimmed] : null;
  }
  return ROLE_CODE_BY_NAME[role as Roles] || null;
}

export function toRoleName(
  role: Roles | RoleCode | string | number | null | undefined
): Roles | null {
  if (role === null || role === undefined) return null;
  if (typeof role === "number") {
    return ROLE_NAME_BY_CODE[role as RoleCode] || null;
  }
  if (typeof role === "string") {
    const trimmed = role.trim();
    if (isRoleName(trimmed)) return trimmed;
    const numeric = Number(trimmed);
    return ROLE_NAME_BY_CODE[numeric as RoleCode] || null;
  }
  return role as Roles;
}

export default Roles;
